import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonType } from 'src/app/shared/common/components/buttons/button';
import { Field } from 'src/app/shared/template-services/field';
import { Template } from 'src/app/shared/template-services/template';
import { TemplateStoreForComponent } from '../../../template/template-store-for-component.service';

@Component({
    selector: 'field-buttons',
    templateUrl: './field-buttons.component.html'
})
export class FieldButtonsComponent {
    @Input()
    field: Field;

    @Input()
    isSelected: boolean;

    @Input()
    template: Template;

    @Output()
    toggleField = new EventEmitter<void>();

    @Output()
    duplicateField = new EventEmitter<void>();

    // expose ButtonType enum to template
    public ButtonType = ButtonType;

    constructor(private templateStoreForComponent: TemplateStoreForComponent) {}

    trashFieldAction(field: Field): void {
        this.template.removeField(field);
        this.templateStoreForComponent.templateEditorFields.next(this.template.fields);
    }

    toggleFieldAction(): void {
        this.toggleField.emit();
        this.templateStoreForComponent.templateEditorFields.next(this.template.fields);
    }
}
